export enum CustomerTypeIds {
  Adult = 1,
  Child = 2,
  Student = 3,
}
